import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { MatSnackBar } from '@angular/material/snack-bar';
import { App, Project, Site, SiteIdentifier } from '../../models';
import { SiteDataDataService } from '../data-services';

@Injectable({
    providedIn: 'root'
})
export class SiteDataLogicService {
    constructor(
        private _siteDataDataService: SiteDataDataService,
        private _snackBar: MatSnackBar
    ) { }

    updateSiteData(app: App, project: Project, site: Site, data: any): Observable<any> {
        const result$ = new Subject<any>();

        this._siteDataDataService.updateSiteData(app, project, site, data)
            .subscribe({
                next: (response: any) => {
                    result$.next(response);
                    result$.complete();
                },
                error: (error: any) => {
                    result$.error(error);
                }
            });

        return result$.asObservable();
    }

    getSitesWithPointCategory(app: App, project: Project, categoryId: string): Observable<SiteIdentifier[]> {
        const result$ = new Subject<SiteIdentifier[]>();

        this._siteDataDataService.getSitesWithPointCategory(app, project, categoryId)
            .subscribe({
                next: (response: SiteIdentifier[]) => {
                    result$.next(response);
                    result$.complete();
                },
                error: (error: any) => {
                    result$.error(error);
                }
            });

        return result$.asObservable();
    }
}
